import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "grid",
    gap: 2,
    maxWidth: 400,
    borderRadius: 8,
    overflow: "hidden",
  },
  grid1: { gridTemplateColumns: "1fr" },
  grid2: { gridTemplateColumns: "1fr 1fr" },
  grid3: { gridTemplateColumns: "1fr 1fr" },
  grid4: { gridTemplateColumns: "1fr 1fr" },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  imageWrap: {
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    // Square aspect ratio via padding trick for browser compat
    "&::before": {
      content: "''",
      display: "block",
      paddingTop: "100%",
    },
  },
  imageInner: {
    position: "absolute",
    inset: 0,
  },
  spanTwo: {
    gridColumn: "1 / -1",
    "&::before": {
      paddingTop: "56.25%", // 16:9
    },
  },
  overlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 24,
    fontWeight: "bold",
    zIndex: 1,
  },
}));

const MediaGrid = ({ messages, onOpen }) => {
  const classes = useStyles();
  const total = messages.length;
  const show = Math.min(total, 4);
  const remaining = total - show;

  const gridClass =
    show <= 1
      ? classes.grid1
      : show === 2
      ? classes.grid2
      : classes.grid4;

  return (
    <div className={`${classes.grid} ${gridClass}`}>
      {messages.slice(0, show).map((msg, i) => {
        const isLast = i === show - 1 && remaining > 0;
        const isSpan = (show === 3 && i === 0) || show === 1;

        return (
          <div
            key={msg.id}
            className={`${classes.imageWrap} ${isSpan ? classes.spanTwo : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              if (onOpen) onOpen(i);
            }}
          >
            <div className={classes.imageInner}>
              {msg.mediaType === "video" ? (
                <video className={classes.image} src={msg.mediaUrl} muted />
              ) : (
                <img
                  className={classes.image}
                  src={msg.mediaUrl}
                  alt=""
                  loading="lazy"
                />
              )}
            </div>
            {isLast && <div className={classes.overlay}>+{remaining}</div>}
          </div>
        );
      })}
    </div>
  );
};

export default MediaGrid;
